export const VARIANT_LABELS = { dr: "DEAR", kl: "KL", golden_raja: "Golden Raja" };
